module.exports = __webpack_public_path__ + "static/media/MrComplain.0d8e8629.jpg";